// extracted by mini-css-extract-plugin
module.exports = {"ProjectActivity_Assigned_Dd":"ProjectActivityAssignedFilter_ProjectActivity_Assigned_Dd__2Fx8i"};